import { Grid, Stack } from '@mui/material';
import CustomButton from 'components/Common/Button';
import TextInput from 'components/Common/TextInput';
import { useForm } from 'react-hook-form';

import { CreateStaff, CreateStaffFormProps } from 'types/staff';

const defaultValues: CreateStaff = {
    firstName: '',
    lastName: '',
    email: '',
};

const CreateStaffForm = ({ loading, onSubmit, submitButtonText }: CreateStaffFormProps) => {
    const { handleSubmit, setValue, watch } = useForm({
        defaultValues,
    });
    const onFormSubmit = (formData: CreateStaff) => {
        onSubmit(formData);
    };
    return (
        <form onSubmit={handleSubmit(onFormSubmit)}>
            <Grid container item xs={12} rowGap={{ xs: 2, sm: 0 }}>
                <Grid
                    container
                    item
                    columnGap={10}
                    rowGap={{ xs: 2, sm: 0 }}
                    direction={{ xs: 'row', sm: 'column' }}
                    justifyContent={'space-between'}
                >
                    <Grid item xs={12}>
                        <TextInput
                            width={'100%'}
                            placeholder="First Name"
                            label="First Name"
                            icon={null}
                            value={watch('firstName')}
                            onChange={(e: any) => setValue('firstName', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} textAlign={{ sm: 'end' }}>
                        <TextInput
                            width={'100%'}
                            icon={null}
                            placeholder="Last Name"
                            label="Last Name"
                            value={watch('lastName')}
                            onChange={(e: any) => setValue('lastName', e.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <TextInput
                        icon={null}
                        sx={{ mb: 4 }}
                        width={'100%'}
                        placeholder="Username@email.com"
                        label="Email"
                        value={watch('email')}
                        onChange={(e: any) => setValue('email', e.target.value)}
                    />
                </Grid>
            </Grid>
            <Stack justifyContent="center" direction="row">
                <CustomButton
                    title={submitButtonText || 'Send Invitation'}
                    type="submit"
                    loading={loading}
                    sx={{ width: { xs: '90%', sm: '40%' } }}
                />
            </Stack>
        </form>
    );
};

export default CreateStaffForm;
